export default "__VITE_ASSET__BXM887PX__"